import ErrorFallback from 'Components/ErrorFallback'
import {
  ServiceProviderCreatePage,
  ServiceProviderEditPage,
  ServiceProviderListPage
} from 'Services/ServiceProviderManagement/Features/ServiceProvider/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function ServiceProviderRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ServiceProviderListPage />} />
        <Route path="create" element={<ServiceProviderCreatePage />} />
        <Route path=":pta/:id/edit" element={<ServiceProviderEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default ServiceProviderRoot
